import React from 'react'
import { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { sendRequest } from '../requests/useRequest';
import { useForm } from '../forms/useForm';
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';



export const usePantalla1 = () => {

	//local Storage
	let id = localStorage.getItem('id');

	const history = useHistory();
	const [method, setMethod] = useState("");
	const [modal, setModal] = useState(false);
	const [modalTitle, setModalTitle] = useState("");
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({})
	const [setFocusNim, setSetFocusNim] = useState(true);
	//	const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate] = useSweetAlert();
	const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal, sweetAcceptGlobal] = useSweetAlert()
	const [isScanning, setIsScanning] = useState(false);

	const [formNim, handleInputChangeNim, resetNim, handleUpdateValuesNim, handleSelectValuesNim] = useForm({
		nim: "",
		id_work_order: 0
	});

	const { nim, id_work_order } = formNim;

	var hoy = new Date();
	var fecha = hoy.getFullYear() + '-' + (hoy.getMonth() + 1) + '-' + hoy.getDate();
	var hora = hoy.getHours() + ':' + hoy.getMinutes() + ':' + hoy.getSeconds();
	var fechaYHora = fecha + ' ' + hora;

	const nimAutoFocus = () => {
		if (setFocusNim) {
			if (document.getElementById("inputFocusNim") !== null) {
				document.getElementById("inputFocusNim").focus();
			}
		}
	}

	useEffect(() => {
		nimAutoFocus()
	}, [setFocusNim]);

	//#region modal

	const openModal = () => {
		setModal(true);
		setSetFocusNim(false);
	}

	const closeModal = () => {
		setModal(false);
		setSetFocusNim(true);
		handleUpdateValuesNim({
			nim: ""
		})
	}

	const handleCardID = () => {
		setMethod("list");
		setModalTitle("Codigo de Barras");
		openModal();
		setSetFocusNim(false);
	}
	//#endregion modal

	//#region Pstient
	const getDataNim = (e) => {
		e.preventDefault();
		setLoading(true);

		if (formNim.nim.length > 0) {
			getDataFromNimPost(formNim.nim);
		}
		else {
			createSweett("", "Debes de ingresar un NIM válido", "warning");
			setLoading(false);
			return;
		}
		setLoading(false);
	}

	const [idWork, setIdWork] = useState(0)
	let gato = 0

	const getDataFromNimPost = async (nimValue) => {

		let _newForm = {
			nim: nimValue.substring(0, 13),
			id_departament: localStorage.getItem('depW')
		}


		let listTmp = await handleRequest("POST", "Sass/GetDataFromPatient", "Sample", _newForm);

		if (listTmp !== null) {
			let _name = "";
			let _surname = "";
			let _id_work_order = 0;

			listTmp.lista_pruebas.forEach(_find => {
				_name = _find.name;
				_surname = _find.surname;
				_id_work_order = _find.id_work_order;
			});

			setData(listTmp.lista_pruebas);
			console.log("🚀 ~ getDataFromNimPost ~ _id_work_order:", _id_work_order)

			setIdWork(_id_work_order);
			gato = _id_work_order;

			// saveCreateSample(_name, _surname);
			saveCreateSample(_name, _surname, nimValue);

			handleUpdateValuesNim(prev => ({
				...prev,
				nim: nimValue,
				id_work_order: _id_work_order
			}));
		}
	}


	//#endregion Patient

	function onKeyPressNim(_event) {
		if (_event.keyCode === 13) {
			let _mValue = _event.target.value;
			setLoading(true);

			if (_mValue.length > 0) {
				getDataFromNimPost(_mValue);
			}
			else {
				createSweett("", "Debes de ingresar un nim valido", "warning");
				handleUpdateValuesNim({
					nim: ""
				});
				setSetFocusNim(true);
				setLoading(false);
			}
		}
	}

	const saveCreateSample = async (_name, _surname, nimValue) => {
		let _newForm = {
			id_user: id,
			nim: nimValue.substring(0, 13),
			name: _name,
			surnames: _surname,
			init: fechaYHora
		}

		////console.log(_newForm);

		//aqui esta../paciente/

		let listTmp = await handleRequest("POST", "Sample/Create", "Sample", _newForm);
		console.log("🚀 ~ saveCreateSample ~ listTmp:", listTmp)

		if (listTmp !== null) {
			localStorage.removeItem('timeInit');
			localStorage.setItem('timeInit', fechaYHora);
			console.log("🚀 ~ saveCreateSample ~ listTmp.is_curve:", listTmp.is_curve)


			if (listTmp.is_curve) {
				history.push('../paciente/' + nimValue.substring(0, 13) + "/" + listTmp.id_sample + "/" + listTmp.is_curve);
			}
			else {
				history.push('../paciente/' + nimValue.substring(0, 13) + "/" + listTmp.id_sample);

			}
		}
		else {
			createSweet("info", "info", "Atención", listTmp.msg);//wilson
			handleUpdateValuesNim({
				nim: ""
			});
			closeModal()
			setSetFocusNim(true);
			setLoading(false);
		}
	}
	console.log(idWork);

	useEffect(() => {
		if (idWork) {
			console.log("ID actualizado:", idWork);
		}
	}, [idWork]);


	const saveIsToma = async (_id_work_order) => {

		console.log(idWork);
		console.log(gato);


		if (gato === 0 || gato === null || gato === undefined) {
			createSweet("info", "info", "Atención", "No se ha podido obtener el nim");
			return;
		}
		let _listTmp = await handleRequest("POST", `Sample/saveisSampling/${gato}`, 'sample');

		if (_listTmp !== null) {
			createSweett("", "Muestras marcadas correctamente , puede continuar con el proceso de recepción de muestra ", "success");
		}
	}




	const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
		let requestOptions = {
			method: method
		};

		if (body !== null) {
			requestOptions = {
				...requestOptions,
				body: JSON.stringify(body)
			};
		}
		const response = await sendRequest(requestOptions, methodUrl);
		console.log("🚀 ~ handleRequest ~ response:", response)

		if (response.code === 200) {
			return response.data;
		}
		else if (response.code === 404) {
			createSweet("info", "info", "Atención", response.data.msg);
		}
		else if (response.code === 409) {

			if (response.data.msg === "Error : ACCEPT") {
				closeModal()
				setSetFocusNim(true);
				setLoading(false);
				const isConfirmed = await sweetAcceptGlobal(
					"Esta muestra ya cuenta con una toma ,  para continuar con el proceso de recepción seleccione el botón , `Si aceptar`",
					"",
					"warning",
					true
				);

				if (isConfirmed) {
					saveIsToma(idWork);
				}

			}
			else {
				createSweet("warning", "warning", "Toma de Muestra", response.data.msg);
			}
		}
		else {
		}
		return null;
	}


	//#region Scanner

	const labels = (nim) => {
		if (!nim) return nim;

		nim = nim.trim();

		if (nim.startsWith("1")) return nim;

		return "1" + nim.slice(1);
	};

	const [showQR, setShowQR] = useState(false);

	const handleScanQR = async (valueQR) => {

		if (isScanning) return;

		if (!valueQR || valueQR.length === 0) {
			createSweett("", "Debes de ingresar un NIM válido", "warning");
			return;
		}

		const nimNormalizado = labels(valueQR);

		setIsScanning(true);

		try {
			await getDataFromNimPost(nimNormalizado);
		} finally {
			setIsScanning(false);
		}

		setShowQR(false);
	};





	//#endregion

	return {
		closeModal, handleCardID, method, modalTitle, modal, loading,
		formNim, getDataNim, data, handleInputChangeNim, nim, fechaYHora, getDataFromNimPost,
		setFocusNim, nimAutoFocus, onKeyPressNim, handleSelectValuesNim,

		handleScanQR, showQR, setShowQR
	}
}